import React from 'react';

type ValidInputTypes = 'email' | 'password' | 'search' | 'tel' | 'text' | 'url';

type TextInputProps = React.HTMLProps<HTMLInputElement> & {
  type: ValidInputTypes;
  'data-qa': string;
};

export const TextInput = React.forwardRef<HTMLInputElement, TextInputProps>(
  (props: TextInputProps, ref?) => {
    const type = props.type || 'text';
    return (
      <input
        ref={ref}
        className="form-input border-1 border-tertiary focus:border-tertiary focus:ring-offset-2 focus:ring-offset-blue-1000 focus:ring-blue-300 focus:ring-1 font-sans mt-1 px-3 py-3 rounded-lg text-base text-gray-1000 w-full transition"
        {...props}
        type={type}
      />
    );
  },
);

TextInput.displayName = 'TextInput';
